module.exports = __webpack_public_path__ + "static/media/vehicle-options@3x.b31c6823.png";